module.exports = __webpack_public_path__ + "media/images/iconClose__errorRed-81ab55d344f272ed84e9f926a1521e54.png";